

export const FETCH_FIXED_TEMPLATES_REQUEST = 'fixedTemplates/FETCH_FIXED_TEMPLATES_REQUEST';
export const FETCH_FIXED_TEMPLATES_SUCCESS = 'fixedTemplates/FETCH_FIXED_TEMPLATES_SUCCESS';
export const FETCH_FIXED_TEMPLATES_FAILURE = 'fixedTemplates/FETCH_FIXED_TEMPLATES_FAILURE';

export const UPDATE_FIXED_TEMPLATES_REQUEST = 'fixedTemplates/UPDATE_FIXED_TEMPLATES_REQUEST';
export const UPDATE_FIXED_TEMPLATES_SUCCESS = 'fixedTemplates/UPDATE_FIXED_TEMPLATES_SUCCESS';
export const UPDATE_FIXED_TEMPLATES_FAILURE = 'fixedTemplates/UPDATE_FIXED_TEMPLATES_FAILURE';

export const UPDATE_FIELD = 'fixedTemplates/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'fixedTemplates/SET_DEFAULT_DATA';
